// 現在のページをヘッダーに伝える
export const setPage = (page: string) => {
  return {
    type: page,
  };
};


// WEBPACK FOOTER //
// ./src/actions/Header.tsx